(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gg-price-filter"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gg-price-range')) {
  customElements.define('gg-price-range', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const minRange = this.querySelector('[data-price-min-range]');
      const maxRange = this.querySelector('[data-price-max-range]');
      const minNumber = this.querySelector('[data-price-min-number]');
      const maxNumber = this.querySelector('[data-price-max-number]');
      const maximum = Number(this.dataset.max);
      const update = (source) => {
        let low = Number(source === minRange ? minRange.value : minNumber.value);
        let high = Number(source === maxRange ? maxRange.value : maxNumber.value);
        low = Math.max(0, Math.min(maximum, Number.isFinite(low) ? Math.round(low) : 0));
        high = Math.max(0, Math.min(maximum, Number.isFinite(high) ? Math.round(high) : maximum));
        if (low > high) {
          if (source === minRange || source === minNumber) low = high;
          else high = low;
        }
        minRange.value = minNumber.value = low;
        maxRange.value = maxNumber.value = high;
        this.style.setProperty('--price-low', maximum ? (low / maximum * 100) + '%' : '0%');
        this.style.setProperty('--price-high', maximum ? (high / maximum * 100) + '%' : '100%');
      };
      [minRange, maxRange, minNumber, maxNumber].forEach(input => input.addEventListener('input', () => update(input)));
      update();
      const form = this.closest('.gg-price-range__form');
      if (form) form.addEventListener('submit', () => {
        form.querySelectorAll('input[type="hidden"]').forEach(input => input.remove());
        for (const [name, value] of new URLSearchParams(window.location.search)) {
          if (name.startsWith('filter.v.price.') || name === 'page' || name === 'section_id') continue;
          const hidden = document.createElement('input');
          hidden.type = 'hidden'; hidden.name = name; hidden.value = value;
          form.append(hidden);
        }
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
